import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var path = process.env.VUE_APP_BASE_API;
import { mapGetters } from 'vuex';
import infoList from '@/mixins/infoList';
import { exportExcel, loadExcelData, downloadTemplate } from '@/api/excel';
import { getMenuList } from '@/api/menu';
export default {
  name: 'Excel',
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getMenuList,
      path: path
    };
  },
  computed: _objectSpread({}, mapGetters('user', ['userInfo', 'token'])),
  created: function created() {
    this.pageSize = 999;
    this.getTableData();
  },
  methods: {
    handleExcelExport: function handleExcelExport(fileName) {
      if (!fileName || typeof fileName !== 'string') {
        fileName = 'ExcelExport.xlsx';
      }
      exportExcel(this.tableData, fileName);
    },
    loadExcel: function loadExcel() {
      this.listApi = loadExcelData;
      this.getTableData();
    },
    downloadExcelTemplate: function downloadExcelTemplate() {
      downloadTemplate('ExcelTemplate.xlsx');
    }
  }
};